import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './RowNumberOrderDetail.less';

export default class RowNumberOrderDetail extends OfficialPage {
  state = {
    orderId: '',
    orderInfo: '',
    orderData: '',
    isShowCancelWindow: false,
    toStoreSetting: '',
    billingStatus: [
      '未支付',
      '',
      '待使用',
      '',
      '退款申请中',
      '退款中',
      '已使用',
      '已关闭'
    ]
  }
  franchiseeId = ''

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail
    })
    this.franchiseeId = options.franchisee || ''
    this.dataInitial()
  }

  dataInitial = () => {
    let _this = this
    this.getTostoreSetting()
    setTimeout(function () {
      _this.getOrderDetail()
    }, 2000)
  }
  getOrderDetail = () => {
    let that = this
    app.getOrderDetail({
      data: {
        order_id: that.data.orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        let data = res.data[0]
        that.setData({
          orderData: data,
          orderInfo: data.form_data
        })
      }
    })
  }
  cancelTakeNumber = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/lineUpOrderRefund',
      method: 'post',
      data: {
        order_id: that.data.orderId
      },
      success: function (res) {
        that.getOrderDetail()
        that.hideCancelWindow()
      }
    })
  }
  showCancelWindow = () => {
    this.setData({
      isShowCancelWindow: true
    })
  }
  hideCancelWindow = () => {
    this.setData({
      isShowCancelWindow: false
    })
  }
  goToCheckRowNunberDetail = () => {
    let that = this
    app.turnToPage(
      '/orderMeal/pages/checkRowNumberDetail/checkRowNumberDetail?orderId=' +
      that.data.orderId +
      (that.franchiseeId ? '&franchisee=' + that.franchiseeId : '')
    )
  }
  getTostoreSetting = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      success: function (res) {
        if (res.status == 0) {
          _this.setData({
            toStoreSetting: res.data
          })
        }
      }
    })
  }

  render() {
    const {
      orderInfo,
      billingStatus,
      toStoreSetting,
      isShowCancelWindow
    } = this.state
    return (
      <React.Fragment>
        <div className="official-page row-number-order-detail">
          <TopNav title="订单详情"/>
          <div className="row-num-head">
            <span>我的排号：</span>
            <span>{orderInfo.line_up_data && (orderInfo.line_up_data.queue_num_name || '未排号')}</span>
          </div>
          <div className="row-num-contain">
            <div>{'号单状态：' + (billingStatus[orderInfo['status']] || '')}</div>
            <div>{'取号时间：' + (orderInfo['add_time'] || '')}</div>
            <div>{'订单号：' + (orderInfo['order_id'] || '')}</div>
          </div>
          <div className="row-num-contain">
            <div>
              {'排号类型：' + (orderInfo && orderInfo.line_up_data && (orderInfo.line_up_data.line_up_type_data ? orderInfo.line_up_data.line_up_type_data.name : orderInfo.line_up_data.line_up_type_name))}
            </div>
            <div>
              {'预计等待：' +
                ((orderInfo.line_up_data && orderInfo.line_up_data.prepare_wait_time) > 0
                  ? (orderInfo.line_up_data.prepare_wait_time >
                    toStoreSetting.max_display_time
                    ? '>' + toStoreSetting.max_display_time
                    : orderInfo.line_up_data.prepare_wait_time) + '分钟'
                  : '无需等待')}
            </div>
          </div>
          <div className="shop-name-contain">
            <div className="shop-name">
              <img src={orderInfo.app_info && orderInfo.app_info.app_logo} />
              <span>{orderInfo.app_info && orderInfo.app_info.app_name}</span>
            </div>
            <div className="cost-box">
              <div>
                排号费：
                <span className="pull-right">
                  {'¥' + (orderInfo.original_price || '')}
                </span>
              </div>
              <div>
                实付金额：
                <span className="pull-right orange">
                  {'¥' + (orderInfo.total_price || '')}
                </span>
              </div>
            </div>
          </div>
          {orderInfo['status'] == 2 && (
            <div className="row-num-btn-box">
              <span onClick={this.showCancelWindow}>取消排队</span>
              <span className="color-btn" onClick={this.goToCheckRowNunberDetail}>
                查看号单
              </span>
            </div>
          )}
          {isShowCancelWindow && (
            <div className="cancel-window">
              <div className="cancel-window-box">
                <div className="cancel-window-content">
                  取消后您的排号信息无法恢复排号费将退款。确定取消？
                </div>
                <div className="cancel-window-btn">
                  <span onClick={this.cancelTakeNumber}>取消排号</span>
                  <span className="orange" onClick={this.hideCancelWindow}>
                    继续排号
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/row-number-order-detail/RowNumberOrderDetail.jsx